// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"Hw","delete_item":"Iw","subscription_item":"Jw","subscription_item_img_wrapper":"Kw","subscription_item_info":"Lw","subscription_item_title":"Mw","subscription_item_edit":"Nw","subscription_item_wrapper":"Ow","arrow":"Pw","subscription_item_category":"Qw","plus_button":"Rw","more_details":"Sw","old_price":"Tw","discount":"Uw"};
    if(module.hot) {
      // 1713211519699
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  